import { Team } from '@bringg/types';
import { getSharedRootStore, hasFeatureFlag } from '@bringg-frontend/global-stores';

export const ENABLE_CUSTOMER_WP_TIMEZONES = 'enable_customer_wp_timezones';

export const isWayPointTimeZoneEnabled = (team?: Team) => {
	const {
		data: { merchantConfigurationsStore, usersStore }
	} = getSharedRootStore();

	return (
		hasFeatureFlag(usersStore.currentUser, ENABLE_CUSTOMER_WP_TIMEZONES, team) &&
		merchantConfigurationsStore.localizeTaskTimezonesByTeams &&
		merchantConfigurationsStore.enableWaypointTimezone
	);
};
